/**
 * Named application error codes.
 */
export enum ApplicationErrors {
	/**
	 * The user can successfully sign in, but must update its password (expired).
	 */
	AuthPasswordExpired = 10001,

	/**
	 * The user can successfully sign in, but must accept GreenRouter terms of service (currently not accepted).
	 */
	AuthRequiresTosAcceptance = 10002,

	/**
	 * The user has been successfully authenticated, but the trial period has expired.
	 */
	AuthUserExpired = 10003,
}
